import { Component } from "@angular/core";

@Component({
  selector: "poa-australia",
  imports: [],
  templateUrl: "./poa-australia.component.html",
  styleUrls: ["../poa-base.component.scss", "./poa-australia.component.scss"],
})
export class PoAAustraliaComponent {}
